import React from "react";

const Edit = ({
  width = 20,
  height = 20,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.796 8.26603L11.7355 7.20553L4.75 14.191V15.2515H5.8105L12.796 8.26603ZM13.8565 7.20553L14.917 6.14503L13.8565 5.08453L12.796 6.14503L13.8565 7.20553ZM6.4315 16.7515H3.25V13.5693L13.3263 3.49303C13.4669 3.35242 13.6576 3.27344 13.8565 3.27344C14.0554 3.27344 14.2461 3.35242 14.3868 3.49303L16.5085 5.61478C16.6491 5.75542 16.7281 5.94615 16.7281 6.14503C16.7281 6.3439 16.6491 6.53463 16.5085 6.67528L6.43225 16.7515H6.4315Z"
        fill="#525866"
      />
    </svg>
  );
};

export default Edit;
